import { graphql } from "~/gql";

export const TECHNOLOGY_UNITS_QUERY = graphql(/* GraphQL */ `
  query FindTechnologyUnits {
    technologyUnits {
      ...TechnologyUnitParts
    }
  }
`);
